export { default } from './ErrorViewDetail';
